import React from 'react';
import skinsStyles from './styles/SolidScreen.scss';
import BaseScreenSkin, { BaseScreenSkinProps } from './BaseScreenSkin';

const SolidScreen: React.FC<
  Omit<BaseScreenSkinProps, 'skin' | 'skinStyles'>
> = props => <BaseScreenSkin {...props} skinStyles={skinsStyles} />;

export default SolidScreen;
